import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import employeeApi from 'src/api/employee';


export const fetchAllEmployee = createAsyncThunk(
  'product/fetchAllEmployee',
  async (page) => {
    const response = await employeeApi.getPageEmployee(page)
    // console.log('Employee Response', response)
    return response
  }
)
const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status: '',
  info: null,
  employeeInfo:[],
  loading: true,
  error: '',
}

const slice = createSlice({
  name: 'employee_info',
  initialState,
  reducers: {
    setEmployeeInfo(oldState, action) {
      const info = action.payload;
      oldState.info = info;
    },

    addEmployee(oldState, action){
      const newEmployee =action.payload
      oldState.employeeInfo=[newEmployee,...oldState.employeeInfo]
    },
    updateEmployee(oldState, action){
      const newEmployee =action.payload

      const newEmployeeInfo=[...oldState.employeeInfo]
      .filter((each)=>each.id!==newEmployee.id)

      oldState.employeeInfo=[newEmployee,...newEmployeeInfo]
    },
    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },
  extraReducers: {
    [fetchAllEmployee.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchAllEmployee.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.employeeInfo = action.payload.content
      state.loading = false
    },
    [fetchAllEmployee.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
});

export const reducer = slice.reducer;

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}


export const setEmployeeInfo = (info) => (dispatch) => {
  dispatch(slice.actions.setEmployeeInfo(info));
}

export const getEmployeeList =  () => async (dispatch) => {
  const info = await employeeApi.getEmployeeList()
  dispatch(slice.actions.getEmployeeList(info));
}

export const addEmployee =(requestbody) => async (dispatch) => {
  const result =await employeeApi.addEmployee(requestbody)
  // console.log('add result', result)
  dispatch(slice.actions.addEmployee(result))
}

export const updateEmployee =(id, requestbody) => async (dispatch) => {
  const result =await employeeApi.updateEmployee(id, requestbody)
  // console.log('update result', result)
  dispatch(slice.actions.updateEmployee(result))
}



export default slice;
